import { shuffle, map } from 'lodash-es';
import move from 'lodash-move';

export default {

  /**
   * Rearrange the order of an array.
   *
   * @param array
   * @param oldIndex
   * @param newIndex
   * @returns {*}
   */
  arrayMove(array, oldIndex, newIndex) {
    return move(array, oldIndex, newIndex);
  },

  /**
   * Remove element in array at index.
   *
   * @param arr
   * @param index
   * @returns {*}
   */
  arrayRemove(arr, index) {
    arr.splice(index, 1);
    return arr;
  },

  /**
   * Shuffle an array.
   *
   * @param arr
   * @returns {Array}
   */
  arrayShuffle(arr) {
    return shuffle(arr);
  },

  /**
   * Rearrange the priority of the image list.
   *
   * @param arr
   */
  rearrangeImageList(arr) {
    return map(arr, (item, index) => ({ ...item, priority: index + 1 }));
  },

  /**
   * Update the image list.
   *
   * @param arr
   * @param image
   * @param index
   */
  updateImageList(arr, image, index) {
    const updatedImageList = [...arr];
    updatedImageList[index] = image;
    return updatedImageList;
  },
};



// WEBPACK FOOTER //
// ./src/utils/converter.js